// 005: the parent cart bound to the shopping context's client (cartStore.ts holds the state).
import { useMemo, useSyncExternalStore } from "react";

import { parentCart } from "./cartStore";
import { useShopping } from "./shopApi";

export function useCart() {
  const { client, store = parentCart } = useShopping();
  const state = useSyncExternalStore(
    store.subscribe,
    store.getSnapshot,
    store.getSnapshot,
  );
  const actions = useMemo(
    () => ({
      load: () => store.load(client),
      setQuantity: (studentId: string, productId: string, q: number) =>
        store.setQuantity(client, studentId, productId, q),
      addFullSet: (studentId: string) => store.addFullSet(client, studentId),
      clearError: store.clearError,
    }),
    [client, store],
  );
  return { ...state, actions };
}
